import DokanPageTitle from '../../components/text/DokanPageTitle';

function EditProfile() {
    return (
        <>
            <div className="min-h-screen container mx-auto">
                <DokanPageTitle>Edit Account</DokanPageTitle>
            </div>
        </>
    );
}

export default EditProfile;
